import type { BaseSlideProps, QuoteContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function QuoteSlide({ title, content, accentColor }: BaseSlideProps) {
  const { quote, author, context } = content as QuoteContent;

  return (
    <div
      className="slide-content flex flex-col items-center justify-center min-h-[600px]"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-serif font-bold mb-12 accent-text">
          {title}
        </h2>

        <div className="accent-border-left pl-8 py-4 mb-6 animate-fade-in-up">
          <p className="text-3xl font-serif italic text-slate-700 dark:text-slate-300 leading-relaxed"
             dangerouslySetInnerHTML={{ __html: `"${inlineMarkdown(quote)}"` }} />
        </div>

        {author && (
          <p className="text-lg text-slate-600 dark:text-slate-400 mb-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            — {author}
          </p>
        )}

        {context && (
          <p className="text-sm text-slate-500 dark:text-slate-500 max-w-xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.3s' }}
             dangerouslySetInnerHTML={{ __html: inlineMarkdown(context) }} />
        )}
      </div>
    </div>
  );
}
